// Ícones (DESIGN §4). lucide-react renderiza SVG inline e herda `currentColor`.
// Use SEMPRE o mapa abaixo para os destinos fixos — ninguém escolhe ícone diferente para a mesma coisa.
// Tamanhos: 24 navegação/ação, 20 linha de lista, 16 chip/badge. Ativo da tab bar: strokeWidth 2.4.
// Ícone sozinho em botão: aria-label no botão. Ícone ao lado de texto: aria-hidden (padrão do lucide).
import {
  ArrowDown,
  ArrowUp,
  ArrowUpDown,
  Award,
  Bell,
  CalendarDays,
  ChartLine,
  ChartNoAxesColumn,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CircleCheck,
  Dumbbell,
  Eye,
  EyeOff,
  Gift,
  House,
  Info,
  KeyRound,
  LayoutGrid,
  ListChecks,
  Lock,
  LogOut,
  Medal,
  Menu,
  MessageSquare,
  Mic,
  Minus,
  Pause,
  Play,
  Plus,
  QrCode,
  Reply,
  Search,
  Send,
  SendHorizontal,
  Settings2,
  ShieldCheck,
  Target,
  Timer,
  TriangleAlert,
  Trophy,
  User,
  Users,
  Workflow,
  X,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";

export type { LucideIcon as TipoIcone, LucideProps as PropsIcone };

/** Mapa fixo de ícones por destino/ação (DESIGN §4). Streak não tem ícone (é o número). */
export const Icones = {
  // aluno
  inicio: House,
  treino: Dumbbell,
  ranking: ChartNoAxesColumn,
  desafios: Target,
  perfil: User,
  mensagens: MessageSquare,
  avisos: Bell,
  checkin: QrCode,
  descanso: Timer,
  conquista: Award,
  medalha: Medal,
  pontosMais: Plus,
  pontosMenos: Minus,
  historico: CalendarDays,
  // painel
  alunos: Users,
  visaoGeral: LayoutGrid,
  exercicios: ListChecks,
  premios: Gift,
  automacoes: Workflow,
  configuracoes: Settings2,
  resultados: ChartLine,
  equipe: ShieldCheck,
  mais: Menu,
  regras: Trophy,
  integracao: KeyRound,
  // ações e estados
  fechar: X,
  voltar: ChevronLeft,
  avancar: ChevronRight,
  expandir: ChevronDown,
  buscar: Search,
  mostrar: Eye,
  ocultar: EyeOff,
  confirmar: Check,
  sucesso: CircleCheck,
  erro: CircleAlert,
  alerta: TriangleAlert,
  info: Info,
  bloqueado: Lock,
  sair: LogOut,
  enviar: SendHorizontal,
  enviado: Send,
  respondeu: Reply,
  microfone: Mic,
  tocar: Play,
  pausar: Pause,
  subir: ArrowUp,
  descer: ArrowDown,
  ordenar: ArrowUpDown,
  mais1: Plus,
  menos1: Minus,
} satisfies Record<string, LucideIcon>;

export type NomeIcone = keyof typeof Icones;

